import { render } from "../views/error.html?vue&type=template&id=29a57896&ts=true&external"
import script from "../scripts/error.ts?vue&type=script&lang=ts&external"
export * from "../scripts/error.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/error.css?vue&type=style&index=0&lang=url&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29a57896"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29a57896', __exports__)) {
    api.reload('29a57896', __exports__)
  }
  
  module.hot.accept("../views/error.html?vue&type=template&id=29a57896&ts=true&external", () => {
    api.rerender('29a57896', render)
  })

}


export default __exports__